<ng-container *ngIf="serverError">
  <div class="modal-header">
    <h4 class="modal-title">Server Error: {{ serverError }}</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
</ng-container>

<ng-container *ngIf="!serverError">

  <div class="modal-header">
    <h4 class="modal-title">Link Accounts</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">

    <table>
      <tr>
        <td class="pr-2">Requesting Customer:</td>
        <td>
          <a [routerLink]="['/customers', relationRequest.requesting_customer_id.toString()]" target="_blank">
            {{ relationRequest.requesting_customer_first_name }} {{ relationRequest.requesting_customer_last_name }}
          </a>
        </td>
      </tr>
      <tr>
        <td class="pr-2">Linked Customer:</td>
        <td>
          <a [routerLink]="['/customers', relationRequest.related_customer_id.toString()]" target="_blank">
            {{ relationRequest.related_customer_first_name }} {{ relationRequest.related_customer_last_name }}
          </a>
        </td>
      </tr>
      <tr>
        <td class="pr-2 pt-3">
          {{ relationRequest.related_customer_first_name }}'s relation to {{ relationRequest.requesting_customer_first_name }}:
        </td>
        <td class="pt-3">
          {{ getRelationTypeDisplay(relationRequest.relation) }}
        </td>
      </tr>
    </table>

    <table class="mt-4">
      <tr>
        <td class="pb-2 pr-3 align-top">Information:</td>
        <td class="pb-2">{{ orgConfigService.getOrganizationConfig().customer_facing_linking_instructions }}</td>
      </tr>
      <tr>
        <td class="pr-3 align-top">Verification:</td>
        <td>{{ orgConfigService.getOrganizationConfig().staff_verification_linking_instructions }}</td>
      </tr>
    </table>

    <div class="form-check mt-4">
      <input class="form-check-input" type="radio" id="approveInput"
             [value]="PendingCustomerRelationAction.approve" [(ngModel)]="selectedAction">
      <label class="form-check-label" for="approveInput">
        Approve linking accounts.
      </label>
    </div>
    <div class="form-check" *ngIf="showHideOption">
      <input class="form-check-input" type="radio" id="hideInput"
             [value]="PendingCustomerRelationAction.hide" [(ngModel)]="selectedAction">
      <label class="form-check-label" for="hideInput">
        Needs more information. Verify at check-in.
      </label>
    </div>
    <div class="form-check">
      <input class="form-check-input" type="radio" id="denyInput"
             [value]="PendingCustomerRelationAction.deny" [(ngModel)]="selectedAction">
      <label class="form-check-label text-danger" for="denyInput">
        Deny linking accounts.
      </label>
    </div>

    <div class="alert alert-danger mb-0 mt-3" role="alert" *ngIf="errorMessage">
      {{ errorMessage }}
    </div>

  </div>

  <div class="modal-footer">

    <button type="button" class="btn btn-secondary"
            (click)="activeModal.close()">
      Cancel
    </button>
    <button type="button" class="btn btn-primary"
            *ngIf="!loadingReviewSubmit"
            (click)="handleSave()"
            [disabled]="!validInputSelected()"
            [class.disabled]="!validInputSelected()">
      Save
    </button>
    <button type="button" class="btn btn-primary disabled" disabled
            *ngIf="loadingReviewSubmit">
      Loading...
    </button>

  </div>

</ng-container>
